import React, {PropsWithChildren, ReactElement} from 'react';
import {FormattedMessage} from 'react-intl';
import {fonts} from '@fo/shared/styles/variables';
import Headers, {HeaderType} from '@fo/designSystem/Text/Headers/Headers';
import Paragraph from '@fo/designSystem/Text/Paragraph/Paragraph';

function EmailSentModalBody({children}: PropsWithChildren<Record<string, unknown>>): ReactElement {
  return (
    <div data-testid="modal.emailSentBody">
      <Headers headerType={HeaderType.H2} alignment={fonts.alignment.CENTER}>
        <FormattedMessage id="phoenix.emailSentModal.title" />
      </Headers>
      <Paragraph alignment={fonts.alignment.CENTER}>
        <FormattedMessage id="phoenix.emailSentModal.content" />
      </Paragraph>
      {children}
    </div>
  );
}

export default EmailSentModalBody;
